import * as z from 'zod/mini';

import { createStorageKeySchema } from '../../../../../services/storage';

export const networkRegistryStorageKeySchema = createStorageKeySchema({
  key: 'lastKnownNetworkRegistry',
  schema: z.record(z.string(), z.string()),
});
